import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { colors } from "../../styles/color";
import Topbar from "../../components/common/Topbar";
import { ArrowLeftGray } from "../../assets/icons";
import { StoreChannel } from "../../components/common/StoreChannel";
import { Helmet } from "react-helmet-async";

export const AddChannel = () => {
  //! Hooks
  const [show, setShow] = React.useState(true);
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>YouTube Channel Setup | Category, Content and Audience</title>
        <meta
          name="description"
          content="Set up your YouTube channel on the dashboard. Add categories, content details, and audience info to optimize visibility and attract brand collaborations."
        />
        {/* Canonical */}
        <link rel="canonical" href="https://quickfluence.com/" />
        {/* Open Graph */}
        <meta
          property="og:title"
          content="Creator Dashboard: Set Up and Manage YouTube Channel"
        />
        <meta
          property="og:description"
          content="Set up your YouTube channel on the dashboard. Add categories, content details, and audience info to optimize visibility and attract brand collaborations."
        />
        <meta property="og:url" content="https://quickfluence.com/" />
        <meta property="og:site_name" content="quickfluence" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="YouTube channel setup dashboard for creators"
        />
        <meta
          property="og:image"
          content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Box
        sx={{
          "& .MuiAppBar-root": {
            position: "sticky",
          },
        }}
      >
        <Topbar>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            textAlign={"center"}
            sx={{ pl: { xl: 0, xs: "20px" } }}
          >
            <Box mr={"15px"}>
              <Typography
                variant="body1"
                fontSize={"18px"}
                lineHeight="27px"
                color={colors.gray[300]}
              >
                Social
              </Typography>
            </Box>
            <Box display={"flex"} alignItems={"center"} mr={"15px"}>
              <ArrowLeftGray />
            </Box>
            <Box
              onClick={() => navigate("/dashboard/social/youtube")}
              sx={{ cursor: "pointer" }}
            >
              <Typography
                variant="body1"
                fontSize={"18px"}
                lineHeight="27px"
                color={colors.gray[300]}
                mr={"15px"}
              >
                YouTube
              </Typography>
            </Box>
            <Box display={"flex"} alignItems={"center"} mr={"15px"}>
              <ArrowLeftGray />
            </Box>
            <Box>
              <Typography variant="body1" fontSize={"18px"} lineHeight="27px">
                Add Channel
              </Typography>
            </Box>
          </Box>
        </Topbar>
        <Box p="0px 16px" mt={"16px"}>
          <Box
            sx={{
              height: "100%",
              background: colors.dark[800],
              borderRadius: "12px",
              color: "white",
              p: { md: "70px 100px 20px", xs: "20px 10px" },
            }}
          >
            <StoreChannel show={show} setShow={setShow} />
          </Box>
        </Box>
      </Box>
    </>
  );
};
